"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Label = _interopRequireDefault(require("./components/Label"));
var _excluded = ["badge", "className", "dataMetrics", "disabled", "fixed", "hoverTitle", "icon", "isFullWidth", "label", "mode", "noTextTransform", "onClose", "secondaryStyle", "subtitle", "tabWidth", "type", "uppercase", "value", "wrappedTabs"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var defaultBorderStyle = function defaultBorderStyle(_ref) {
    var secondaryStyle = _ref.secondaryStyle,
      isStaticMode = _ref.isStaticMode;
    return secondaryStyle || isStaticMode ? 'none' : "1px solid ".concat(theme.palette.opacity.black[8]);
  };
  var correctTextTransformStyle = function correctTextTransformStyle(_ref2) {
    var noTextTransform = _ref2.noTextTransform,
      uppercase = _ref2.uppercase;
    var textTransform = uppercase ? 'uppercase' : 'capitalize';
    return noTextTransform ? 'none' : textTransform;
  };
  var focusBorder = {
    border: "2px solid ".concat(theme.palette.opacity.black[87])
  };
  var selectedBorder = {
    border: "2px solid ".concat(theme.palette.primary.main)
  };
  var selectedText = {
    color: theme.palette.primary.main
  };
  var focusedText = {
    color: theme.palette.opacity.black[60]
  };
  var disabledText = {
    color: theme.palette.opacity.black[38]
  };
  return {
    disabled: _objectSpread({}, disabledText),
    focusVisible: {
      '&$secondaryStyle': {
        paddingTop: '6px'
      },
      '&$selected': _objectSpread({
        '&:last-of-type, &:first-of-type': _objectSpread({}, selectedBorder, {}, selectedText)
      }, selectedBorder, {}, selectedText),
      '&:not($selected)': _objectSpread({
        '&:last-of-type': _objectSpread({}, focusBorder)
      }, focusBorder, {}, focusedText, {
        backgroundColor: theme.palette.opacity.black[4]
      }),
      padding: function padding(_ref3) {
        var isStaticMode = _ref3.isStaticMode;
        return isStaticMode ? 0 : "1px 0 0 1px";
      }
    },
    root: _objectSpread({
      '&$disabled': _objectSpread({}, disabledText),
      '&:hover': {
        '& .label-badge': {
          backgroundColor: theme.palette.opacity.black[87]
        },
        '&$focusVisible': {
          borderTop: 'none',
          paddingTop: function paddingTop(_ref4) {
            var isStaticMode = _ref4.isStaticMode;
            return isStaticMode ? '2px' : '3px';
          }
        },
        '&:not($selected)': {
          boxShadow: "0 2px 0 ".concat(theme.palette.opacity.black[87], " inset"),
          color: theme.palette.opacity.black[87],
          opacity: 1
        }
      },
      backgroundColor: theme.palette.opacity.black[4]
    }, focusedText, {
      height: theme.spacing(6),
      maxWidth: 'none',
      minWidth: theme.spacing(10),
      opacity: 1,
      padding: 0
    }),
    secondaryStyle: _objectSpread({}, focusedText, {
      '&$disabled': {
        color: theme.palette.opacity.black[38]
      },
      '&:hover': {
        '&$focusVisible': {
          borderBottom: 'none',
          paddingBottom: '2px'
        },
        '&:$selected': {
          paddingBottom: '2px'
        },
        '&:not($selected)': {
          boxShadow: "0 -2px 0 ".concat(theme.palette.opacity.black[87], " inset"),
          color: theme.palette.opacity.black[87],
          opacity: 1
        }
      },
      minWidth: theme.spacing(10)
    }),
    selected: _objectSpread({}, selectedText, {
      backgroundColor: theme.palette.common.white
    }),
    subtitle: _objectSpread({}, theme.typography.overline),
    tab: {
      '&:last-of-type': {
        borderRight: defaultBorderStyle
      },
      borderLeft: defaultBorderStyle,
      borderTop: defaultBorderStyle,
      flexGrow: function flexGrow(_ref5) {
        var isFullWidth = _ref5.isFullWidth;
        return isFullWidth ? 1 : 0;
      },
      flexShrink: function flexShrink(_ref6) {
        var isFullWidth = _ref6.isFullWidth;
        return isFullWidth ? 1 : 0;
      },
      paddingLeft: '2px',
      paddingRight: '2px',
      width: function width(_ref7) {
        var tabWidth = _ref7.tabWidth,
          isFullWidth = _ref7.isFullWidth;
        return isFullWidth ? '100%' : "".concat(tabWidth, "px");
      }
    },
    textTransformStyle: {
      textTransform: correctTextTransformStyle
    },
    wrappedTabs: {
      minWidth: theme.spacing(8)
    },
    wrapper: {
      padding: function padding(_ref8) {
        var icon = _ref8.icon,
          isFullWidth = _ref8.isFullWidth;
        if (isFullWidth) {
          return theme.spacing(0);
        }
        if (icon) {
          return theme.spacing(0, 1);
        }
        return theme.spacing(0, 2);
      },
      width: '100%'
    },
    wrapperDynamic: {
      paddingLeft: theme.spacing(1),
      paddingRight: 0,
      width: '100%'
    }
  };
});
var defaultProps = {
  dataMetrics: {
    closeIcon: 'fuse_tab_close_icon',
    root: 'fuse_tab'
  },
  disabled: false,
  onClose: function onClose() {},
  textColor: 'inherit',
  type: 'static',
  uppercase: false,
  wrappedTabs: false
};

/**
 * Static Tabs are an easy way to organize content by grouping similar information on the same page. This allows content to be viewed without having to navigate away from that page. Tabs display all tabs in a set simultaneously.
 */
var Tab = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _cx, _cx2;
  var badge = props.badge,
    className = props.className,
    dataMetrics = props.dataMetrics,
    disabled = props.disabled,
    fixed = props.fixed,
    hoverTitle = props.hoverTitle,
    icon = props.icon,
    isFullWidth = props.isFullWidth,
    label = props.label,
    mode = props.mode,
    noTextTransform = props.noTextTransform,
    onClose = props.onClose,
    secondaryStyle = props.secondaryStyle,
    subtitle = props.subtitle,
    tabWidth = props.tabWidth,
    type = props.type,
    uppercase = props.uppercase,
    value = props.value,
    wrappedTabs = props.wrappedTabs,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var isStaticMode = [mode, type].includes('static');
  var classes = useStyles({
    fixed: fixed,
    icon: icon,
    isFullWidth: isFullWidth,
    isStaticMode: isStaticMode,
    noTextTransform: noTextTransform,
    secondaryStyle: secondaryStyle,
    tabWidth: tabWidth,
    uppercase: uppercase
  });
  var singleTabOnClose = function singleTabOnClose(event) {
    event.stopPropagation();
    event.nativeEvent.preventDefault(); // In order to stop propagation on the the Link react-router needs to pass the preventDefault
    onClose(event, value);
  };
  var labelBadge = badge;
  if (badge) {
    labelBadge = /*#__PURE__*/_react["default"].cloneElement(badge, {
      className: 'label-badge'
    });
  }
  var handleAccessibilityClose = function handleAccessibilityClose(event) {
    var backSpace = 8; // On mac this is the delete key
    var deleteKey = 46;
    if (event.keyCode === backSpace || event.keyCode === deleteKey) {
      singleTabOnClose(event);
    }
  };
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var TabComponent = /*#__PURE__*/_react["default"].createElement(_Tab["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])((_cx = {}, (0, _defineProperty2["default"])(_cx, classes.tab, classes.tab), (0, _defineProperty2["default"])(_cx, className, className), _cx)),
    onKeyDown: handleAccessibilityClose,
    focusVisibleClassName: classes.focusVisible,
    classes: {
      disabled: classes.disabled,
      labelIcon: classes.labelIcon,
      root: (0, _classnames["default"])(classes.textTransformStyle, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, classes.root, secondaryStyle === undefined), (0, _defineProperty2["default"])(_cx2, classes.secondaryStyle, secondaryStyle !== undefined), (0, _defineProperty2["default"])(_cx2, classes.wrappedTabs, wrappedTabs), _cx2)),
      selected: classes.selected,
      wrapper: (0, _classnames["default"])(classes.wrapper, (0, _defineProperty2["default"])({}, classes.wrapperDynamic, type === 'dynamic'))
    },
    "data-metrics": mergedDataMetrics.root,
    label: /*#__PURE__*/_react["default"].createElement(_Label["default"], {
      badge: labelBadge,
      dataMetrics: mergedDataMetrics,
      fixed: fixed,
      icon: icon,
      label: label,
      mode: mode,
      onClose: singleTabOnClose,
      subtitle: subtitle,
      tabWidth: tabWidth,
      type: type,
      wrappedTabs: wrappedTabs
    }),
    ref: ref,
    value: value,
    disabled: disabled
  }, rest));
  return hoverTitle ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: hoverTitle
  }, TabComponent) : TabComponent;
});
Tab.defaultProps = defaultProps;
Tab.displayName = 'Tab';
Tab.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The badge element.
   */
  badge: _propTypes["default"].element,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/tab/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    closeIcon: _propTypes["default"].string,
    root: _propTypes["default"].string
  }),
  /**
   * If `true` the tab will be disabled.
   */
  disabled: _propTypes["default"].bool,
  /**
   * fixed is a static tab that does not have the close icon
   * @ignore
   */
  fixed: _propTypes["default"].bool,
  /**
   * When in mode `dynamic` fixed tabs align all the way to the left
   * and are not closeable.
   */
  hoverTitle: _propTypes["default"].string,
  /**
   * The icon element.
   */
  icon: _propTypes["default"].node,
  /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: _propTypes["default"].node,
  /**
   * passed by parent container TabGroup to control css.
   */
  isFullWidth: _propTypes["default"].bool,
  /**
   * The label string or node if you want to render things like tooltips etc.
   */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * @ignore
   */
  mode: _propTypes["default"].oneOf(['dynamic', 'static']),
  /**
   * @ignore
   */
  /**
   * If `true` will disable all text formatting
   * and the label will be the casing you pass in.
   */
  noTextTransform: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  /**
   * @ignore
   */
  onClick: _propTypes["default"].func,
  /**
   * Callback to invoke when close button of a dynamic tab is clicked.
   */
  onClose: _propTypes["default"].func,
  /**
   * If `true` the tab background is white and indicator will appear at bottom.
   */
  secondaryStyle: _propTypes["default"].bool,
  /**
   * @ignore
   */
  selected: _propTypes["default"].bool,
  /**
   * The subtitle string.
   * ** Note that subtitle will not show on static tabs within the Tabs component.
   */
  subtitle: _propTypes["default"].string,
  /**
   * width of the tab in pixels.
   */
  tabWidth: _propTypes["default"].number,
  /**
   * @ignore
   */
  textColor: _propTypes["default"].oneOf(['secondary', 'primary', 'inherit']),
  /**
   * Specify the type of tab that should be rendered.
   * dynamic: Dynamic Tab with the close icon
   * static: Static Tab with no close icon
   */
  type: _propTypes["default"].oneOf(['dynamic', 'static']),
  /**
   * If false, uppercase conversion will not be applied to tab text.
   * By default the tab text will be uppercase you must explicitly
   * pass in false to override that to camel case.
   */
  uppercase: _propTypes["default"].bool,
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: _propTypes["default"].any,
  /**
   * True to indicate the parent tabs are wrapped by an outer container, which is the case for TabGroup.
   */
  wrappedTabs: _propTypes["default"].bool
} : {};
var _default = Tab;
exports["default"] = _default;